import React, { useState, useEffect } from 'react';
import RWBUserImages from '../RWBUserImages';
import styles from './ProfileDetail.module.css';
import { IconButton, Grid } from '@material-ui/core';
import SettingsIcon from '../svgs/SettingsIcon';
import EditIcon from '../svgs/EditIcon';
import { userProfile } from '../../../../shared/models/UserProfile';
import { rwbApi } from '../../../../shared/apis/api';
import FeedList from '../feed/FeedList';
import { ClipLoader } from 'react-spinners';
import { useRouteMatch, useHistory } from 'react-router-dom';
import ExpandingText from '../ExpandingText';
import moment from 'moment';
import {
  logEditButton,
  logAccessFollowers,
  logAccessFollowing,
  logAccessAppSettings,
} from '../../../../shared/models/Analytics';
import { hasReachedBottom } from '../../BrowserUtil';
import Loading from '../Loading';
import AppMark from '../../../../shared/project-info/web-project-info/svgs/AppMark';
import { paymentConfig } from '../../../../shared/project-info/paymentConfig';
import { formatStatusTitle } from '../../../../shared/utils/Helpers';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import { PROFILE_TAB_LABELS } from '../../../../shared/constants/Labels';
import ChevronRightIcon from '../svgs/ChevronRightIcon';
import { errorAlert } from '../../../../shared/utils/ErrorAlert';

export default function ProfileDetail() {
  const [isFollowSummaryLoading, setIsFollowSummaryLoading] = useState(true);
  const [isInitialFeedLoading, setIsInitialFeedloading] = useState(true);
  const [isMoreFeedLoading, setIsMoreFeedLoading] = useState(false);
  const [followingAmount, setFollowingAmount] = useState('-');
  const [followersAmount, setFollowersAmount] = useState('-');
  const [userFeed, setUserFeed] = useState([]);
  const [retrievedLastPost, setRetrievedLastPost] = useState(false);
  const user = userProfile.getUserProfile();
  const match = useRouteMatch();
  const history = useHistory();
  const [userMetric, setUserMetric] = useState({});
  const [userbadges, setuserBadges] = useState([]);
  useEffect(() => {
    getUsersFollowSummary(user.id);
    getFeed();
    if (projectConfig.hasChallenges) {
      getUserMetrics()
      getBadges()
    }

  }, []);

  // getUserMetrics getBadges requires the backend has fitpros-style workouts
  const getUserMetrics = () => {
    rwbApi.getUserMetrics().then((result) => {
      setUserMetric(result.data)
    });
  };
  const getBadges = () => {
    rwbApi
      .getUserBadges(userProfile.getUserProfile().id)
      .then((result) => {
        setuserBadges(result.data.badges)
      })
      .catch((error) => {
        console.warn(error);
        errorAlert("Error retrieving user's badges.");
      });
  };


  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);
    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [userFeed]);

  useEffect(() => {
    // replacement for setState callback
    if (retrievedLastPost) handleLoadMore();
  }, [retrievedLastPost]);

  const trackScrolling = (event) => {
    event.preventDefault();
    const wrappedElement = document.getElementById('root');
    if (hasReachedBottom(wrappedElement)) {
      setRetrievedLastPost(true);
    }
  };

  const getUsersFollowSummary = (id) => {
    return rwbApi
      .getFollowSummary(id)
      .then((result) => {
        const followingAmount = result.following;
        const followersAmount = result.followers;
        setFollowingAmount(followingAmount);
        setFollowersAmount(followersAmount);
        setIsFollowSummaryLoading(false);
      })
      .catch((error) => {
        console.warn(error);
        errorAlert("Error retrieving user's following and follower count.");
      });
  };

  const getFeed = () => {
    rwbApi
      .getUserFeed(user.id)
      .then((result) => {
        setUserFeed(result.data.results);
        setIsInitialFeedloading(false);
      })
      .catch((error) => {
        console.warn('error getting feed: ', error);
        errorAlert('There was an error retrieving your feed.');
        setIsInitialFeedloading(false);
      });
  };

  const handleLoadMore = () => {
    const lastPost = userFeed[userFeed.length - 1];
    setIsMoreFeedLoading(true);
    if (retrievedLastPost && lastPost) {
      rwbApi.getUserFeed(user.id, lastPost.id).then((result) => {
        if (result.data.results.length > 0) {
          setUserFeed([...userFeed, ...result.data.results]);
          setIsMoreFeedLoading(false);
          setRetrievedLastPost(false);
        } else setIsMoreFeedLoading(false);
      });
    }
  };
const navigateChallange = () =>{
  history.push('/challenges')
}
const navigateBadges = () =>{
  history.push(
    {
      pathname: '/challengebadges',
      state: {badgesData: userbadges},
    }
  )
}
  return (
    <div id={'root'}>
      {!isFollowSummaryLoading && !isInitialFeedLoading ? (
        <>
          <div className={styles.userImageContainer}>
            <RWBUserImages
              coverPhoto={user.cover_photo_url}
              profilePhoto={user.profile_photo_url}
            />

            <div className={styles.navigation}>
            <IconButton
                edge="start"
                color="inherit"
                onClick={() => {
                  history.push({ pathname: `${match.path}/edit`, });
                }}>
                <EditIcon />
              </IconButton>
              <IconButton 
                edge="start" 
                color="inherit"
                onClick={() => {
                  logAccessAppSettings();
                  history.push(`${match.path}/settings`);
                }}>
                <SettingsIcon />
              </IconButton>
            </div>
          </div>
          <div className={styles.contentContainer}>
          <div>
            {projectConfig.hasPayment &&  <div
                className={`${styles.editButton} ${styles.donationBtn}`}
                onClick={() => {
                  history.push(`${match.path}/settings/membershipoptionview`)
                }}>
                {
                  user.latest_purchase?.expiration_date ? 
                  `${paymentConfig.appSettingsMembershipLabel} ${user.latest_purchase?.expiration_date ? `(valid until ${moment(user.latest_purchase?.expiration_date).format('MM/DD/YYYY')})`:''}`: 
                  `${paymentConfig.membershipPurchaseLinkText}`
                }
              </div>}
            </div>
            {/* Name */}
            <div className={styles.nameContainer}>
              <h1>{`${user.first_name} ${user.last_name}`}</h1>
              {/* {user.eagle_leader && (
                <AppMark tintColor={'var(--secondary)'} width={40} height={18} />
              )} */}
            </div>
            {/* Chapter/Workspace */}
            {user.workspace || user.preferred_chapter || user.home_chapter ?
              <h2 className={styles.chapterContainer}>
                {projectConfig.showProfileChapter ?
                  (user.preferred_chapter && user.preferred_chapter.name) ||
                  (user.home_chapter && user.home_chapter.name)
                : user.workspace && user.workspace.name}
              </h2>
            : null}
            {/* Leadership Title */}
            {user.eagle_leader && projectConfig.leaderRoleDisplay ? (
              <div className={styles.roleContainer}>
                <h5 className={styles.eagleLeaderText}>
                  {projectConfig.leaderRoleDisplay}
                </h5>
              </div>
            ): null}
            {/* Industry */}
            {user.extra_info?.industry &&
              <h6 className={styles.industryContainer}>
                {user.purchaseData?.description ? user.purchaseData?.description + ", " : null}
                {user.extra_info?.industry}
              </h6>
            }
            {/* Service and Branch */}
            {user.service_info?.status || user.service_info?.service_type ?
              <div className={styles.roleContainer}>
                <h3 style={{textAlign: 'center'}}>
                  {formatStatusTitle(user.service_info?.status, user.service_info?.service_type)}
                </h3>
              </div>
            : null}
            {/* Followers and Following */}
            <div className={styles.profileActions}>
              <div
                className={styles.followCount}
                onClick={() => {
                  logAccessFollowers();
                  history.push({
                    pathname: `${match.path}/followers`,
                    state: { index: 0 },
                  });
                }}>
                <strong>{followersAmount}</strong>
                followers
              </div>
              <div
                className={styles.followCount}
                onClick={() =>
                  logAccessFollowing() +
                  history.push({
                    pathname: `${match.path}/followers`,
                    state: { index: 1 },
                  })
                }>
                <strong>{followingAmount}</strong>
                following
              </div>
            </div>

            <h2>
              {formatStatusTitle(
                user?.service_info?.status,
                user?.service_info?.service_type,
              )}
            </h2>
            {/* <p>
              {user.military_status === MILITARY_STATUSES.veteran &&
                `ETS: ${moment(user.military_ets).format('Y')}`}
            </p> */}
            <br />
            <ExpandingText text={user.profile_bio} />
          </div>

          {projectConfig.hasChallenges && (
            <div className={styles.contentContainer}>
              <div className={[styles.contentContainerDiv]}>
                <div onClick={() => {
                  history.push(`/workoutlogs`);
                }} className={[styles.metricBox]}>
                  <p className={styles.metricLink}>{PROFILE_TAB_LABELS.EVENT_AND_WORKOUT_STATS}</p>
                  <div>
                    <ChevronRightIcon />
                  </div>

                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', padding: 5 }}>
                  <div style={{ width: '30%' }}>
                    <p className={[styles.metricNum]}> {userMetric.all_time_challenges_participated}</p>
                    <p className={[styles.metricLable]}>{PROFILE_TAB_LABELS.ALL_TIME_CHALLENGES}</p>
                  </div>
                  <div style={{ width: '30%' }}>
                    <p className={[styles.metricNum]}> {userMetric.mtd_events_participated}</p>
                    <p className={[styles.metricLable]}>{PROFILE_TAB_LABELS.YTD_EVENTS}</p>
                  </div>
                  <div style={{ width: '30%' }}>
                    <p className={[styles.metricNum]}>  {userMetric.ytd_events_participated}</p>
                    <p className={[styles.metricLable]}>{PROFILE_TAB_LABELS.MTD_EVENTS}</p>
                  </div>
                </div>
              </div>


              {/* badges view */}
              <div className={[styles.contentContainerDiv]}>
                <div onClick={() => { userbadges.length > 0 && navigateBadges() }} className={[styles.metricBox]}>
                  <p className={styles.metricLink}>{PROFILE_TAB_LABELS.CHALLENGE_BADGES}</p>
                  {userbadges.length > 0 && <div>
                    <ChevronRightIcon />
                  </div>
                  }
                </div>
                <div>
                  {userbadges.length > 0 ?
                    <div onClick={() => { navigateBadges() }} className={[styles.imageContainerFlex]}>
                      {userbadges.map((badge, index) => {
                        return (index < 6) ?
                          <img
                            key={index}
                            src={badge.image_url}
                            alt="badge"
                          />
                        : null
                      })}
                    </div>
                    :
                    <div className={[styles.noUserBadgesContainer]} onClick={() => {
                      navigateChallange()
                    }}>
                      <div className={[styles.emptyContainer]}>

                      </div>
                      <div className={[styles.emptyContainer]}>

                      </div>
                      <div className={[styles.emptyContainer]}>

                      </div>
                      <div className={[styles.noUserBadgesContainer]}>
                        <div>
                          <p>{PROFILE_TAB_LABELS.JOIN_CHALLENGES_EARN_BADGES}</p>
                        </div>
                        <div>
                          <ChevronRightIcon />
                        </div>
                      </div>
                    </div>
                  }
                </div>

              </div>

              {/* analytics view */}
              {projectConfig.hasInAppAnalytics && user.eagle_leader &&
                <div className={[styles.contentContainerDiv]}>
                  <div onClick={() => {
                    history.push(`/analytics`);
                  }} className={[styles.metricBox]}>
                    <p className={styles.metricLink}>{projectConfig.inAppAnalyticsLabel}</p>
                    <div>
                      <ChevronRightIcon />
                    </div>
                  </div>
                </div>}
            </div>
          )}
          <FeedList
            userFeed={userFeed}
            origin={'user'}
            mergeNewPost={getFeed}
          />
          <Grid container justifyContent={'center'}>
            <ClipLoader
              size={60}
              color={'var(--grey20)'}
              loading={isMoreFeedLoading}
            />
          </Grid>
        </>
      ) : (
        <Loading size={100} color={'var(--white)'} loading={true} right />
      )}
    </div>
  );
}
